import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { isInternalScrollRoute } from "@/config/routes";
import { Sidebar } from "@/features/layout/components/Sidebar";
import { SiteFooter } from "@/features/layout/components/SiteFooter";
import { TopBar } from "@/features/layout/components/TopBar";
import { recordPageVisit } from "@/lib/analytics/recordPageVisit";
import { cn } from "@/utils/cn";

export function AppShell() {
  const { pathname } = useLocation();
  const isInternalScrollPage = isInternalScrollRoute(pathname);

  useEffect(() => {
    void recordPageVisit(pathname);
  }, [pathname]);

  return (
    <div className="flex h-screen overflow-hidden bg-[var(--bg)]">
      <Sidebar />
      <div
        className={cn(
          "flex min-h-0 min-w-0 flex-1 flex-col",
          isInternalScrollPage && "app-main-column--compact-download",
        )}
      >
        <TopBar />
        <main
          className={cn(
            "web-page flex min-h-0 flex-1 flex-col",
            isInternalScrollPage
              ? "web-page--compact-download overflow-hidden"
              : "overflow-y-auto",
          )}
        >
          <Outlet />
        </main>
        {!isInternalScrollPage ? <SiteFooter /> : null}
      </div>
    </div>
  );
}
